// removed by extract-text-webpack-plugin
module.exports = {"heading":"_2DHIU-P","isNew":"_160HRoV","link":"_2aj1BbW","icon":"mxPSLy3","items":"_2ci4MeA","noItems":"_2ZeB9ny","viewAll":"_36n7tOf","chevron":"_2khk-D-","chevronSvg":"_3s4vdxS"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/HomePage/components/Dashboard/components/SignedInDashboard/components/RecommendedJobsDashboard/RecommendedJobsDashboard.less
 ** module id = 775
 ** module chunks = 0
 **/